
import { Component, Prop, Vue } from 'vue-property-decorator';
import type { Project } from '@/models/project';
import PhaseWorksheet from '@/components/projects/fields/PhaseWorksheet.vue';

@Component({
    name: 'ProjectViewTradesGrid',
    components: {
        PhaseWorksheet,
    },
})
export default class ProjectViewTradesGrid extends Vue {
    @Prop({
        required: true,
    })
    private project: Project;
}
